import styled, { css } from 'styled-components';

export const ModalContainer = styled.div<{ $active }>`
  position: fixed;
  inset: 0 0 0 0;
  z-index: -1;
  transition: 0.3s;
  visibility: hidden;
  ${({ $active }) =>
    $active
      ? css`
          z-index: 101;
          visibility: visible;
        `
      : null}
`;

export const ModalContainerBg = styled.div<{ $active: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: 0.2s;
  opacity: 0;
  background: rgba(31, 44, 81, 0.65);
  visibility: hidden;

  ${({ $active }) =>
    $active
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : null}
`;

export const ModalContainerContent = styled.div<{ $active: boolean }>`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 100vh);
  background: #ffffff;
  box-shadow: 0px 4px 50px rgba(57, 102, 197, 0.13);
  border-radius: 20px;
  transition: 0.15s;
  padding: ${({ theme }) => theme.spacing.x3};

  ${({ $active }) =>
    $active
      ? css`
          transform: translate(-50%, -50%);
        `
      : null}
`;
export const ModalContainerContentHead = styled.div`
  display: flex;
  justify-content: flex-end;
`;
